module.exports = __webpack_public_path__ + "img/13-fourImg.339e80ff.png";